import { filter, find, isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { reviewSelectors } from '..';
import { getUserId } from '../helpers/session';
import { getSelectedProfileId } from '../helpers/profile';
import { getCurrentShowId } from './shows';

/**
 * Returns a review matching a specified ID
 */
export const getReviewById = reviewSelectors.selectById;

export const getUserReviewsForShow = createSelector(
  reviewSelectors.selectAll,
  getUserId,
  getCurrentShowId,
  (reviews, userId, showId) => {
    if (!reviews) {
      return null;
    }

    const filteredReviews = filter(reviews, (review) => review.owner === userId && review.showId === showId);

    if (isEmpty(filteredReviews)) {
      return null;
    }

    return filteredReviews;
  },
);

export const getProfileReviewForShow = createSelector(
  reviewSelectors.selectAll,
  getUserId,
  getCurrentShowId,
  getSelectedProfileId,
  (reviews, userId, showId, selectedProfileId) => {
    if (!reviews) {
      return null;
    }

    return find(reviews, (review) => review.owner === userId && review.showId === showId && review.selectedProfileId === selectedProfileId);
  },
);
